import { parseDate, formatDate, formatDateTime } from '../../../../utils/dateUtils';
export { parseDate, formatDate, formatDateTime };

export const SUPPORT_LEVEL_OPTIONS = [
  { value: 1, label: 'Nivel 1 - Basico' },
  { value: 2, label: 'Nivel 2 - Avanzado' },
  { value: 3, label: 'Nivel 3 - Desarrollo Software' },
  { value: 4, label: 'Nivel 4 - Externo' }
];

export const formatDurationMinutes = mins => {
  if (mins === null || mins === undefined || isNaN(mins)) return null;
  const m = Number(mins);
  if (m < 1) return '< 1 min';
  if (m < 60) return `${m} min`;
  const hours = Math.floor(m / 60);
  const remMins = m % 60;
  if (hours < 24) {
    return remMins > 0 ? `${hours}h ${remMins}m` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  return remHours > 0 ? `${days}d ${remHours}h` : `${days}d`;
};

export const formatWaitingTimeFromDate = dateStr => {
  const d = parseDate(dateStr);
  if (!d) return null;
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 0) return '< 1 min';
  const diffMins = Math.floor(diffMs / 60000);
  return formatDurationMinutes(diffMins);
};
